import { Component, OnInit, ViewChild, EventEmitter, Inject, PLATFORM_ID, TemplateRef, Renderer2, ElementRef } from '@angular/core';
import { DOCUMENT } from '@angular/platform-browser';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { filter, map, switchMapTo, take, takeLast, tap } from 'rxjs/operators';
import { Router, NavigationEnd } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ShipperApi } from './core/http/shipper.api.service';

import { AuthenticationService } from './core/authentication/authentication.service';
import { environment } from '../environments/environment';
import { CommonApi } from './core/http/common.api.service';
import { SignalRService } from './core/services/signal-r';
import { AccountRoles } from './shared/constants/account-roles.enum';
import { HeaderComponent } from './layout/header/header.component';
import { LoaderComponent } from './shared/components/loader/loader.component';
import { ISlimScrollOptions, SlimScrollEvent } from 'ngx-slimscroll';
import { isPlatformBrowser } from '@angular/common';
import * as moment from 'moment';
import * as jwt_decode from "jwt-decode";
import { NgbModal, NgbModalConfig, } from '@ng-bootstrap/ng-bootstrap';
import { LoaderService } from './shared/components/loader/loader.service';
import * as appVersion from '../app-version.json';
import { Observable } from 'rxjs';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  redirectUrl = environment.aadConfig.redirect_url;
  preRegistrationString: string;
  @ViewChild('preRegistrationModal') preRegistrationModalRef: TemplateRef<any>;
  @ViewChild('preRegistrationWelcomeModal') preRegistrationModalWelcomeRef: TemplateRef<any>;
  @ViewChild('marqueesContent') marqueesContent: ElementRef;
  title = 'eFCL-SPA';
  isAuthorized: boolean;
  completeInit = false;
  isPreRegistration: boolean = false;
  @ViewChild(HeaderComponent) header: HeaderComponent;
  @ViewChild(LoaderComponent) loader: LoaderComponent;
  isBrowser;
  modalWelcomeRef = null;
  showMarquee = false;
  constructor(
    private renderer2: Renderer2,
    private oidcSecurityService: OidcSecurityService,
    private authService: AuthenticationService,
    private shipperApi: ShipperApi,
    private translate: TranslateService,
    private commonApi: CommonApi,
    private signalRService: SignalRService,
    private router: Router,
    private modalService: NgbModal,
    private modalConfig: NgbModalConfig,
    @Inject(DOCUMENT) private document: HTMLDocument,
    @Inject(PLATFORM_ID) private platformId,
    private loaderService: LoaderService) {
    this.isBrowser = isPlatformBrowser(platformId);
    if (this.isBrowser) {
      this.modalConfig.backdrop = 'static';
      const responseURl = window.location.href;
      if (responseURl.indexOf('error') > -1) {
        this.handleCallBackError(responseURl);
      }

      this.commonApi.getAppConfiguration().subscribe(
        (result: any) => {
          this.isPreRegistration = result.isPreRegistration;
          localStorage.setItem('isPreRegistration', this.isPreRegistration.toString());
          localStorage.setItem('preRegistrationString', result.preRegistrationString);
          let hasToken = responseURl.indexOf('#id_token');
          if (hasToken > -1) {
            const token = responseURl.substr(hasToken + 10);
            const jsonToken = this.getDecodedAccessToken(token);
            if (this.isPreRegistration) {
              if (jsonToken.newUser) {
                localStorage.setItem('showPopupPreRegistration', 'true');
                this.modalService.open(this.preRegistrationModalRef,
                  { centered: true, windowClass: 'pre-registration-modal', backdropClass: 'backdrop-blur' });
                this.router.navigate(['/home'], { queryParams: { successful: true } });
              }
            } else {
              window.location.href = responseURl.substr(0, hasToken - 1); //remove token because it can force user logout when refresh
            }
          }
        }
      );

      this.oidcSecurityService.getIsModuleSetup().pipe(
        filter((isModuleSetup: boolean) => isModuleSetup),
        take(1)
      ).subscribe((isModuleSetup: boolean) => {
        this.doCallbackLogicIfRequired();
      });
      window.onresize = (e) => {
        this.onResize();
      }
    }
  }
  ngOnInit() {
    console.log(`AppVersion:${appVersion.version}`);
    console.log(`AppVersionParentCommit:${appVersion.versionParentCommit}`);
    this.loader.setStatusInit(this.completeInit);

    new Observable<boolean>((subscriber) => {
      if (this.oidcSecurityService.moduleSetup) {
        subscriber.next(true);
        subscriber.complete();
      }
      else {
        this.oidcSecurityService.onModuleSetup.pipe(take(1)).subscribe(() => {
          subscriber.next(true);
          subscriber.complete();
        });
      }
    })
      .pipe(
        switchMapTo(this.oidcSecurityService.getIsAuthorized()),
      ).subscribe(isAuthorized => {
        this.isAuthorized = isAuthorized;

        // console.log('is module setup  ' + this.oidcSecurityService.moduleSetup);
        // console.log('is Authorized  ' + this.isAuthorized)

        this.completeInit = true;
        this.loader.setStatusInit(this.completeInit);


        this.translate.get('PublicNote').subscribe(res => {
          this.showMarquee = res && res.length;
        });
        if (isPlatformBrowser(this.platformId)) {
          if (isAuthorized) {
            this.authService.getUserClaims().subscribe(claim => {
              // If checked-shipper-existing = True, that means the user is exist in the database
              // Otherwise we have to create an shipper account.
              const accountCheckedFlagName = `checked-shipper-existing_${claim.oid}_${claim.tokenAuthTime}`;
              const accountChecked = localStorage.getItem(accountCheckedFlagName);
              if (!accountChecked && claim.role.toLowerCase() === AccountRoles.Shipper) {
                this.shipperApi.isExist(claim.oid).subscribe(resp => {
                  if (!resp) {
                    this.shipperApi.create(claim).subscribe(res => {
                      localStorage.setItem(accountCheckedFlagName, 'true');
                    });
                  } else {
                    localStorage.setItem(accountCheckedFlagName, resp);
                  }
                });
              }
            });


            this.commonApi.getUserSetting().subscribe(setting => {
              localStorage.setItem('date-time-format', setting.dateTimeFormat);
              localStorage.setItem('language', setting.language);
              localStorage.setItem('timeZone', setting.timeZone);
              this.header.onLanguageChange(setting.language);
              this.translate.use(setting.language);
            });

            this.commonApi.getRequestConfiguration().subscribe(config => {
              localStorage.setItem('request-configuration', JSON.stringify(config));
            });

            this.signalRService.startConnection();
            this.signalRService.addPushNotificationListener();
          } else {
            // setup languge for landing page
            let lang = localStorage.getItem('language');
            if (lang != null && lang != '') {
              this.translate.use(lang);
            } else {
              this.translate.use('en');
            }
            this.showWelcome();
          }
        } else {
          this.translate.use('en');
        }

      });

    this.onResize();
  }



  private handleCallBackError(error: string) {
    // Error Code: AADB2C90118 - forgot password
    if (this.isBrowser) {
      if (error.indexOf('AADB2C90118') > -1) {
        window.location.href = environment.aadConfig.stsServer + 'authorize?p=' + environment.aadConfig.password_reset_policy + '&client_id=' + environment.aadConfig.client_id + '&nonce=defaultNonce&redirect_uri=' + environment.aadConfig.redirect_url + '&scope=openid&response_type=id_token&prompt=login';
        return;
      }
      if (error.indexOf('AADB2C90091') > -1) { //cancel sign up
        return;
      }
      else {
        window.location.href = environment.aadConfig.redirect_url;
        return;
      }
    }
  }
  public signUp() {
    this.authService.login();
  }

  public signOut() {
    this.authService.logout();
  }

  private doCallbackLogicIfRequired() {
    if (this.isBrowser) {
      if (window.location.hash) {
        this.oidcSecurityService.authorizedImplicitFlowCallback();
      }
    }
  }

  onResize() {
    if (this.isBrowser) {
      if (document.body.offsetWidth < 1900) {
        document.body.style.overflowX = 'auto';
      } else {
        document.body.style.overflowX = 'hidden';
      }
    }
  }

  getDecodedAccessToken(token: string): any {
    try {
      return jwt_decode(token);
    }
    catch (Error) {
      return null;
    }
  }

  showWelcome() {
    if (this.isBrowser) {
      this.preRegistrationString = localStorage.getItem('preRegistrationString');
      const isPreRegistration = localStorage.getItem('isPreRegistration');
      const showPopupPreRegistration = localStorage.getItem('showPopupPreRegistration');
      if (isPreRegistration === 'true' && showPopupPreRegistration !== 'true') {
        if (this.modalWelcomeRef == null) {
          this.modalWelcomeRef = this.modalService.open(this.preRegistrationModalWelcomeRef,
            { centered: true, windowClass: 'pre-registration-modal welcome-modal', backdropClass: 'backdrop-blur' });
          setTimeout(() => {
            this.modalWelcomeRef.close();
            this.modalWelcomeRef = null;
          }, 5000);
        }

        this.router.navigate(['/home'], { queryParams: { welcome: true } });
        localStorage.removeItem('isPreRegistration');
      }
    }
  }
  startAnimation() {
    this.renderer2.setStyle(this.marqueesContent.nativeElement, 'animation-play-state', 'running');
  }
  stopAnimation() {
    this.renderer2.setStyle(this.marqueesContent.nativeElement, 'animation-play-state', 'paused');
  }
  closeMarquee() {
    this.showMarquee = false;
  }
}
